import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Link } from "react-router-dom";
import { signOut } from "../../authStore";
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';
import authStore from '../../authStore';
import { observer } from 'mobx-react'

const Navigation = observer(() => {
  const loggedIn = authStore.loggedIn.get()
  const currentUser = loggedIn && authStore.user.get()
  return (
    <div>
      <List>
        <ListItem button key="0" style={{ textAlign: 'right' }}>
          <Link to="/"><ArrowForwardOutlinedIcon /></Link>
        </ListItem>
        <hr style={{ margin: 0 }} />
        <ListItem button key="3" style={{ textAlign: 'right' }}>
          <Link to="/about"><ListItemText primary="אודות" classes={{ primary: 'menuItemText' }} /></Link>
        </ListItem>
        <hr style={{ margin: 0 }} />
        {currentUser && currentUser.admin ? <ListItem button key="3" style={{ textAlign: 'right' }}>
          <Link to="/manage"><ListItemText primary="ניהול" classes={{ primary: 'menuItemText' }} /></Link>
        </ListItem>: null}
        
        <hr style={{ margin: 0 }} />
        {loggedIn ?
          <ListItem button key="4" style={{ textAlign: 'right' }} onClick={signOut}>
            <Link to="/"><ListItemText primary="יציאה" classes={{ primary: 'menuItemText' }} /></Link>
          </ListItem> :
          <ListItem button key="4" style={{ textAlign: 'right' }} >
            <Link to="/connect"><ListItemText primary="כניסה" classes={{ primary: 'menuItemText' }} /></Link>
          </ListItem>}
      </List>
    </div>
  )

}


);

export default Navigation;